import { z } from 'zod'

export const subscriptionStatusSchema = z.object({
  profile: z.union([z.literal('technician'), z.literal('practician')]).nullable(),
  status: z.enum(['trial', 'active', 'unpaid', 'canceled']).nullable(),
  blocked: z.boolean(),
  reason: z.string(),
  trial_end: z.string().nullable(),
})

export type SubscriptionStatusApiResponse = z.infer<typeof subscriptionStatusSchema>

export type SubscriptionStatusReason =
  | 'ok'
  | 'practician_included'
  | 'billing_blocked'
  | 'trial_expired'
  | 'no_subscription'
  | 'missing_profile'
  | 'not_authenticated'

export type SubscriptionStatus = {
  profile: 'technician' | 'practician' | null
  status: 'trial' | 'active' | 'unpaid' | 'canceled' | null
  blocked: boolean
  reason: SubscriptionStatusReason
  trialEnd: string | null
}
